<template>
  <v-dialog v-if="dialogVisible" v-model="dialogVisible" max-width="1000px" min-height="1100px">
    <v-card>
      <v-toolbar dark color="primary" elevation="0">
        <v-btn icon dark @click="handleCloseViewer">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ fileViewerData.file.title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn v-if="rotationAvailable" icon class="mr-2" @click="handleCounterClockwiseRotateButtonClick">
          <i class="fas fa-undo"></i>
        </v-btn>
        <v-btn v-if="rotationAvailable" icon>
          <i class="fas fa-redo" @click="handleClockwiseRotateButtonClick"></i>
        </v-btn>
        <v-btn @click="handleDownloadButtonClick" class="ml-5" color="blue darken-1"
               :disabled="progress('fileViewer.download')"
               :loading="progress('fileViewer.download')">
          <v-icon left small>fas fa-file-download</v-icon>
          Download
        </v-btn>
      </v-toolbar>
      <v-card-text class="text--primary text-center">
        <v-progress-circular
            :size="70"
            :width="7"
            style="margin-top: 230px"
            color="primary"
            indeterminate
            v-if="progress('fileViewer.open')"
        ></v-progress-circular>
        <div class="mt-3">
          <pdf-viewer v-if="fileType === 'pdf'" :source="fileViewerData.file.source" @loaded="handleFileLoaded" :rotate="rotate"></pdf-viewer>
          <image-viewer v-if="fileType === 'image'" :source="fileViewerData.file.source" @loaded="handleFileLoaded" :rotate="rotate"></image-viewer>
          <unknown-viewer v-if="fileType === 'unknown'" :source="fileViewerData.file.source" @loaded="handleFileLoaded"></unknown-viewer>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import PdfViewer from './Pdf'
import UnknownViewer from './Unknown'
import ImageViewer from './Image'
import {mapActions, mapGetters, mapState} from 'vuex'
import api from '../../../api'
import FileSaver from 'file-saver'

export default {
  name: "FileViewer",
  components: {
    PdfViewer,
    ImageViewer,
    UnknownViewer
  },
  data() {
    return {
      rotate: 0
    }
  },
  computed: {
    ...mapGetters({
      progress: 'progress'
    }),
    ...mapState({
      fileViewerData: 'fileViewerData'
    }),
    rotationAvailable() {
      return this.fileType === 'image' || this.fileType === 'pdf'
    },
    fileType() {
      switch (this.fileViewerData.file.mimeType) {
        case 'application/pdf':
          return 'pdf'
        case 'image/jpeg':
          return 'image'
        case 'image/png':
          return 'image'
        case 'image/gif':
          return 'image'
        default:
          return 'unknown'
      }
    },
    dialogVisible: {
      get() {
        return this.fileViewerData.file.source !== null
      },
      set(value) {
        if (!value) {
          this.fileViewerClose()
        }
      }
    }
  },
  methods: {
    ...mapActions({
      stopProgress: 'stopProgress',
      startProgress: 'startProgress',
      fileViewerCloseAction: 'fileViewerClose'
    }),
    handleFileLoaded() {
      this.stopProgress('fileViewer.open')
    },
    handleCloseViewer() {
      this.fileViewerClose()
      this.$emit('close', true)
    },
    async handleDownloadButtonClick() {
      this.startProgress('fileViewer.download')

      try {
        let fileData = await api.getFileFromSource(this.fileViewerData.file.source)
        let blob = new Blob([fileData], { type: this.fileViewerData.file.mimeType })

        let fileName = this.fileViewerData.file.title

        if (this.fileViewerData.file.downloadFileName !== null) {
          fileName = this.fileViewerData.file.downloadFileName
        }

        FileSaver.saveAs(blob, fileName)
      } catch (e) {
        console.log(`Unable to download file, details: ${e.message}`)
      } finally {
        this.stopProgress('fileViewer.download')
      }
    },
    handleCounterClockwiseRotateButtonClick() {
      if (this.rotate === 0) {
        this.rotate = 270
        return
      }
      this.rotate -= 90
    },
    handleClockwiseRotateButtonClick() {
      if (this.rotate === 360) {
        this.rotate = 90
        return
      }
      this.rotate += 90
    },
    fileViewerClose() {
      this.fileViewerCloseAction()
      this.rotate = 0
    }
  }
}
</script>

<style scoped>

</style>